
export const COLOUR_SCHEME = [
    {'color':'#115f9a','text':'Тёмно-синий'},
    {'color':'#1984c5','text':'Синий'},
    {'color':'#22a7f0','text':'Светло-синий'},
    {'color':'#48b5c4','text':'Бирюзовый'},
    {'color':'#006400','text':'Тёмно-зелёный'},
    {'color':'#76c68f','text':'Зелёный'},
    {'color':'#a6d75b','text':'Светло-зелёный'},
    {'color':'#8B0000','text':'Тёмно-красный'},
    {'color':'#FF0000','text':'Красный'},
    {'color':'#CD5C5C','text':'Светло-красный'}
]

